(function () {
  var OptimalDistanceColumnGenerator = function (batchGeoTable) {
    const DISTANCE_COLUMN_NAME = "Distance Between Points";
    // this is sufficent to apply the distance column to the dataview
    // this function does add this column to the legend as a selectable grouping

    var generateColumn = function (dataArray) {
      var mapsManager = window.batchGeoGoogleMapsManager;
      var mapRS = batchGeoTable.options.data.mapRS;
      var distanceScale = mapsManager.getDistanceScale();
      var indicies = dataArray.map((row) => Number(Object.keys(row)[0]));

      window.per.columnNames.push(DISTANCE_COLUMN_NAME);

      if (
        window.batchGeoGoogleMapsMarker.MarkerLegend.isActive() &&
        window.per.legend_columns &&
        window.per.legend_columns.length
      ) {
        window.per.legend_columns.push(window.per.legend_columns.length);
      }

      batchGeoTable.addColumn(
        DISTANCE_COLUMN_NAME,
        mapRS.map(function (row, rowIndex) {
          let location = indicies.indexOf(rowIndex);
          return location !== -1
            ? dataArray[location][indicies[location]][
                dataArray[location][indicies[location]].length - 2
              ] +
                " " +
                distanceScale
            : "";
        }),
        batchGeoTable.data.columns.length,
      );

      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
      return distanceScale;
    };

    var removeColumn = function () {
      var distanceColumnIndex =
        batchGeoTable.data.columns.indexOf(DISTANCE_COLUMN_NAME);
      var distanceWindowIndex =
        window.per.columnNames.indexOf(DISTANCE_COLUMN_NAME);
      batchGeoTable.removeColumn(distanceColumnIndex);
      if (window.per.columnNames)
        window.per.columnNames.splice(distanceWindowIndex, 1);
      if (
        window.batchGeoGoogleMapsMarker.MarkerLegend.isActive() &&
        window.per.legend_columns &&
        window.per.legend_columns.length
      )
        window.per.legend_columns.splice(distanceWindowIndex, 1);
      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
    };

    return {
      generateColumn: generateColumn,
      removeColumn: removeColumn,
    };
  };

  window.OptimalDistanceColumnGenerator = OptimalDistanceColumnGenerator;
})();
